import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Navigation from './components/Navigation';
import Login from './pages/Login';
import FileBrowser from './pages/FileBrowser';
import AdminDashboard from './pages/AdminDashboard';
import ShareView from './pages/ShareView';
import { useAuth } from './context/AuthContext';

function App() {
  return (
    <Router>
      <Navigation />
      <Container className="mt-4">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><FileBrowser /></PrivateRoute>} />
          <Route path="/folder/*" element={<PrivateRoute><FileBrowser /></PrivateRoute>} />
          <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/share/:shareId" element={<ShareView />} />
        </Routes>
      </Container>
    </Router>
  );
}

// Private route wrapper for authenticated users
function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  return isAuthenticated ? children : <Navigate to="/login" />;
}

// Admin route wrapper for admin users
function AdminRoute({ children }) {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  const isAdmin = isAuthenticated && user?.role === 'admin';
  console.log('[DEBUG] AdminRoute check: isAuthenticated =', isAuthenticated, 'user =', user, 'role =', user?.role, '=> isAdmin =', isAdmin);

  return isAdmin ? children : <Navigate to="/" />;
}

export default App;
